var React = require('react');

function Down (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m84.898 22.898c3.6016 0 7.1992 1.5 9.6992 4.5 4.5 5.3984 3.6992 13.301-1.6016 17.801l-34.898 29.102c-4.6992 3.8984-11.5 3.8984-16.199 0l-34.898-29.102c-5.3984-4.5-6.1016-12.398-1.6016-17.801 4.5-5.3984 12.398-6.1016 17.801-1.6016l26.801 22.301 26.801-22.301c2.3984-1.9961 5.1992-2.8984 8.0977-2.8984z"}));
}

Down.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Down;

Down.default = Down;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/down.svg
// module id = 384
// module chunks = 0